import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { DashboardPod, EzTuxParentApplication } from '@jfw/types';
import { Observable, of } from 'rxjs';

export enum WholesaleDataPodType {
  THIS_WEEK = 'THIS_WEEK',
  NEXT_WEEK = 'NEXT_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  DUPLICATE_ORDERS = 'DUPLICATE_ORDERS',
  MISSING_SIZES = 'MISSING_SIZES',
  LATE_RETURN = 'LATE_RETURN',
  POTENTIAL_EVENTS = 'POTENTIAL_EVENTS',
}

@Injectable({
  providedIn: 'root',
})
export class WholesaleDataPodsService {
  private readonly http = inject(HttpClient);

  private platformOrderBaseUrl: string = '';

  public readonly podsLastUpdated = signal<number | undefined>(0);

  public setPlatformOrderBaseUrl(url: string): void {
    this.platformOrderBaseUrl = url;
  }

  public getPodData(
    parentApplication: EzTuxParentApplication,
    actnum: string | null,
    eztPodKind: WholesaleDataPodType,
    forceLoad: boolean,
  ): Observable<DashboardPod | null> {
    if (!actnum) {
      console.error('actnum is null or undefined');
      return of(null);
    }

    let url: string;

    switch (parentApplication) {
      case 'jfwplatformportal':
        // proxyLocal used for local development; the LB gateway hostname used for
        // deployed sites (EXT-6709 -- firebase.json no longer rewrites this path).
        url = `${this.platformOrderBaseUrl}/api/jfw-platform-order/platform-portal/eztux/v1/pod/${eztPodKind}/${actnum}`;
        break;
      case 'dealerportal':
        // use full API URL for Dealer Portal (cannot use firebase.json rewrites for cross-project APIs)
        // platformOrderBase URL is set to '' for local development - enables DP to /api segment and proxyLocal for local development
        url = `${this.platformOrderBaseUrl}/api/jfw-platform-order/dealer-portal/eztux/v1/pod/${eztPodKind}/${actnum}`;
        break;
      default:
        // parent_application is not currently being set in EZ-Tux - use as default
        // EZ-Tux requires full API URL
        url = `${this.platformOrderBaseUrl}/api/jfw-platform-order/eztux/eztux/v1/pod/${eztPodKind}/${actnum}`;
    }

    if (forceLoad) {
      url += `/true`;
    }

    return this.http.get<DashboardPod>(url, {
      ...requireAppCheck,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getCookie('ezt-api-token')}`, // Needed for EZ-Tux; Dealer/Platform Portals will overwrite this with Firebase auth token via interceptor
      },
    });
  }

  private getCookie(name: string): string {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
